import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body {
    .ww-main {
      overflow: visible;
    }

    & * {
      font-family: 'Muli', 'Mulish', sans-serif;
    }
  }
  .page-loading-spinner-wrap {
    width: 100vw;
    height: 100vh;
    text-align: center;
    line-height: 100vh;
  }
  .button-loading-spinner-wrap {
    width: 100%;
    height: 100%;
    line-height: 16px;
  }
`;
